import {APIENDPOINT} from '../constants';
var APIURL = window.bookingsUrl + APIENDPOINT;

export default {
  init() {
    var AUTH = window.AUTH;
    $('.event-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst:true,
      dots: true,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false,
          }
        },
      ],
      prevArrow: $('.event-slider-prev-button'),
      nextArrow: $('.event-slider-next-button'),
    });

	function sortByKeyAsc(array, key) {
        return array.sort(function (a, b) {
            var x = a[key]; var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    }


    if ($('.my-bookings').length > 0) {
      $.ajax({
        url: APIURL + 'users/me',
        method: 'GET',
        beforeSend: function (req) {
          req.setRequestHeader('Authorization', AUTH);
        },
        success: function (response) {
	        
	        
	    $.ajax({
	        method: 'GET',
	        url: window.my_ajax_object.ajax_url,
	        dataType: "json",
	        data: {
	          action: 'user_rsvp_events'
	        }, success: function (responseEvents) {
/*
				console.log(responseEvents.data);
				console.log(response);
*/
if(responseEvents.data==null) responseEvents.data=[];
				
				var newJson=[];
				
				for(var a=0;a<responseEvents.data.length;a++){
					newJson.push(responseEvents.data[a]);
				}
				for(var b=0;b<response._embedded.bookings.length;b++){
					newJson.push(response._embedded.bookings[b]);
				}
// 				console.log(newJson);

      
          var $bookings = $('.my-bookings');
         
// 		  console.log(mergedJson);

          var mybookings = sortByKeyAsc(newJson ,"from");
          var html = "";
          if(mybookings.length>0){
            $('.upcoming-activities').show();
          }
          var monthNames = [
              "Jan", "Feb", "Mar",
              "Apr", "May", "Jun", "Jul",
              "Aug", "Sep", "Oct",
              "Nov", "Dec"
            ];
            var date;
            var toDate
            var month;
            var day;
            var from;
            var to;
          for(var i = 0; i < mybookings.length; i++){
	          
	        var booking = mybookings[i];  
	         
	         date = new Date(booking.from.replace(/UTC/g, 'T')+"Z");
           
            
            month = monthNames[date.getMonth()];
            day = date.getDate();
            from = (date.getUTCHours()<10?'0':'')+date.getUTCHours()+':'+(date.getUTCMinutes()<10?'0':'')+date.getUTCMinutes();
            
            
	         console.log(booking.type);
	        if(booking.type==undefined){
            
            var url = HOME_URL + '/bookings/'+booking.id;
             toDate = new Date(booking.to.replace(/UTC/g, 'T')+"Z");
             to = (toDate.getUTCHours()<10?'0':'')+toDate.getUTCHours()+':'+(toDate.getUTCMinutes()<10?'0':'')+toDate.getUTCMinutes();
            html += `

            <a href="${url}" class="md:w-1/2 py-3 px-2 no-underline">
					    <div class="border-white border-2 h-48 flex rounded-lg activities-module">
						    <div class="flex flex-col w-2/3 text-left p-6 justify-around">
							      <p class="text-lg font-light">ROOM BOOKING</p>
							      <h4 class="text-2xl md:text-3xl">${booking.roomName}</h4>
							      <p class="text-lg font-light">Passcode: ${booking.roomDoorCode}</p>
						    </div>
						    <div class="flex flex-col border-l-2 border-white w-1/3 pb-1 justify-center items-center">
                  <p class="bold text-xl alschlange">${month}</p>
                  <p class="bold text-5xl alschlange">${day}</p>
                  <p class="pt-4 font-light text-lg">${from}-${to}</p>
						    </div>
					    </div>
				    </a>

            `
            }else{
// 	            .replace(/-/g, '/').replace(/:/g, ',').replace(/UTC/g, ',')
	            var toDateString=booking.to.replace(/UTC/g, 'T')+"Z";
	            console.log(toDateString, "toDateString");
	            toDate = new Date(toDateString);
	            console.log(toDate, booking.to);
	            from = (date.getHours() < 10?'0':'')+date.getHours()+':'+(date.getMinutes()<10?'0':'')+date.getMinutes();
	            to = (toDate.getHours() < 10?'0':'')+toDate.getHours()+':'+(toDate.getMinutes()<10?'0':'')+toDate.getMinutes();
	            html += `

            <a href="${booking.link}" class="md:w-1/2 py-3 px-2 no-underline">
					    <div class="border-white border-2 h-48 flex rounded-lg activities-module">
						    <div class="flex flex-col w-2/3 text-left p-6 justify-around">
							      <p class="text-lg font-light">EVENT</p>
							      <h4 class="text-2xl md:text-3xl">${booking.title}</h4>
							      <p class="text-lg font-light"></p>
						    </div>
						    <div class="flex flex-col border-l-2 border-white w-1/3 pb-1 justify-center items-center">
                  <p class="bold text-xl alschlange">${month}</p>
                  <p class="bold text-5xl alschlange">${day}</p>
                  <p class="pt-4 font-light text-lg">${from}-${to}</p>
						    </div>
					    </div>
				    </a>

            `
            }
          }
          var $myBookings = $('.my-bookings');
          $myBookings.html(html);
          
          
				
				
	        }, error: function (error) {
	          console.log("error", error);
	        }
      });
      

        }, error: function (error) {
          console.log("error bookings", error);
        }
      });

    }
    //Slider for videos

    var windowWidth = $(window).width();

    $(window).resize(function() {
      if ($(window).width() != windowWidth) {
        windowWidth = $(window).width();

        toggleSlider();
      }
    });

    var sliderEnabled = false;

    function toggleSlider() {
      if (windowWidth > 640) {
        //Desktop
        if (sliderEnabled) {
          $('.videos').slick('unslick');
          sliderEnabled = false;
        }
      } else {
        //Smartphone
        if (!sliderEnabled) {
          $('.videos').slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            mobileFirst: true,
            arrows: false
          });
          sliderEnabled = true;
        }
      }
    }

    toggleSlider();
  }
};
